<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "tigerLoad",
  props: {
    loadPos: {
      type: Number,
      required: false,
      default: 0.75
    },
    loadFun: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      lastHeight: window.pageYOffset
    }
  },
  methods: {
    isAjax () {
      /* 
       防止dom没插完前上滑导致的加载
      */
      const pageYOffset = window.pageYOffset
      if (this.lastHeight < pageYOffset) {
        if (pageYOffset / (document.documentElement.scrollHeight - window.innerHeight) >= this.loadPos) {
          this.loadFun()
          this.lastHeight = pageYOffset
        }
      }
    },
    throttle (fun) {
      clearTimeout(fun.tId);
      fun.tId = setTimeout(() => fun(), 300)
    },
    loadMore () {
      this.throttle(this.isAjax)
    },
    bindLoad () {
      window.addEventListener("scroll", this.loadMore, false)
    },
    removeLoad () {
      window.removeEventListener("scroll", this.loadMore, false)
    }
  },
  mounted () {
    this.loadFun()
    this.bindLoad()
  },
  beforeDestroy () {
    this.removeLoad()
  }
}
</script>



// WEBPACK FOOTER //
// src/lib/load.vue